import { ChartToTSEvent } from '@thoughtspot/ts-chart-sdk';
export var NativeChartToTSEvent;
(function (NativeChartToTSEvent) {
    NativeChartToTSEvent["MuzeStudioCodegen"] = "MuzeStudioCodegen";
    NativeChartToTSEvent["GetBlinkFlags"] = "GetBlinkFlags";
    NativeChartToTSEvent["GetLDFlags"] = "GetLDFlags";
})(NativeChartToTSEvent || (NativeChartToTSEvent = {}));
//# sourceMappingURL=event-processor.types.js.map